import { proxy } from 'valtio'
import { CommonApi, CourseOption, Option } from '../../generated'
import { apiConfig } from '../apiConfig'
import { isJa } from '../i18n/useLang'
import { convertProgramType, ProgramType } from '../ProgramType'

export const coursesStore = proxy<{ items: CourseOption[] }>({
  items: [],
})

new CommonApi(apiConfig).getCourses().then((result) => {
  coursesStore.items = result
})

const api = new CommonApi(apiConfig)
export async function loadCourses() {
  await api.getCourses().then((result) => {
    coursesStore.items = result
  })
}

export function getCoursesName(id?: number, defaultValue?: string) {
  if (!id) return
  return getCourseName(coursesStore.items, id, defaultValue)
}

// todo id の型を変更
export function getCourseName(items: CourseOption[], id: number, defaultValue?: string, isOther?: boolean) {
  const found = items.find((i) => i.id === id)
  if (found === undefined || isOther) return defaultValue
  return isJa() ? found.nameJa : found.name
}

export function getCoursesNameOptions(
  courses: { items: CourseOption[] },
  programType?: ProgramType
) {
  const key = isJa() ? 'nameJa' : 'name'
  const result = courses.items.map((c) => ({
    ...c,
    // value: c.code,
    label: c[key],
  }))
    .filter((c) => {
      // 何も指定されてない場合はfilterしない
      if (programType === undefined || programType === null) return true
      const types = c.programTypes.map((t) => convertProgramType(t))
      return types.includes(programType)
    })
  result.sort((a, b) => {
    if (a.label < b.label) {
      return -1
    } else if (a.label === b.label) {
      return 0
    } else {
      return 1
    }
  })
  return result
}
